import * as React from "react";
import { jsx as _jsx } from "@emotion/react/jsx-runtime";
const SvgIconBling = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 12,
	height: 12,
	viewBox: "0 0 12 12",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("g", {
		id: "Group 2853",
		children: /* @__PURE__ */ _jsx("path", {
			id: "Star 1",
			d: "M6 0C7.0286 2.77974 9.22026 4.9714 12 6C9.22026 7.0286 7.0286 9.22026 6 12C4.9714 9.22026 2.77974 7.0286 0 6C2.77974 4.9714 4.9714 2.77974 6 0Z",
			fill: "#00ABFF"
		})
	})
});
export default SvgIconBling;
